import { render, staticRenderFns } from "./BetModal.vue?vue&type=template&id=18aa40e9&scoped=true"
import script from "./BetModal.vue?vue&type=script&lang=js"
export * from "./BetModal.vue?vue&type=script&lang=js"
import style0 from "./BetModal.vue?vue&type=style&index=0&id=18aa40e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa40e9",
  null
  
)

export default component.exports